import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import * as RadioGroupRadix from '@radix-ui/react-radio-group';
import { ButtonRadioItem } from './ButtonRadioItem';
const rootStyles = {
    basic: css({
        display: 'flex',
        flexDirection: 'row',
        width: 'fit-content',
    }),
    button: (variant) => css({
        ' & > *:first-of-type, & > *:first-of-type span': {
            borderRadius: variant === 'default' ? '6px 0 0 6px' : '4px 0 0 4px',
        },
        ' & > *:last-of-type, & > *:last-of-type span': {
            borderRightWidth: 1,
            borderRadius: variant === 'default' ? '0 6px 6px 0' : '0 4px 4px 0',
        },
    }),
};
export function RadioGroup(props) {
    const { id, selected, disabled: groupDisabled = false, options = [], onSelect, name = '', variant = 'default', } = props;
    return (_jsx(RadioGroupRadix.Root, { id: id, css: [rootStyles.basic, rootStyles.button(variant)], style: {
            gap: 0,
        }, value: selected?.value, name: name, disabled: groupDisabled, children: options?.map(({ value, label, disabled }) => {
            const childProps = {
                value,
                label,
                disabled: groupDisabled || disabled,
                onSelect,
                variant,
                name,
            };
            return _jsx(ButtonRadioItem, { ...childProps }, value);
        }) }));
}
//# sourceMappingURL=RadioGroup.js.map